(() => {
  if (window.__rnfCarouselMedia) { window.__rnfCarouselMedia.mount(document); return; }

  const rimSources = {"47_e7eef282-f9a0-49f8-8caf-90c3ec7daeb0.gif":["1777828640",864,864,34,18,124,4.15],"45-ezgif.com-optimize.gif":["1773246964",864,864,34,18,124,4.15],"82-ezgif.com-optimize.gif":["1773247436",864,864,34,18,124,4.15],"108_d1f062d5-4b41-4d3b-ac11-b35b78533293.gif":["1791448146",864,864,34,18,124,4.15],"Spinning_864_x_864_px_13_1.gif":["1779545618",691,691,26.5,14,100,4.15],"39_23636f90-9b09-4dfe-b877-87114c3e4ba2.gif":["1767977501",864,864,34,18,124,4.15],"43_d4bfa3e2-662e-4a9b-acb6-7791dfd6ac49.gif":["1767977555",864,864,34,18,124,4.15],"32_66af2065-9dcb-414c-b3e9-cceea382e692.gif":["1767977434",864,864,34,18,124,4.15],"152_9716a17d-bcfa-4353-9ab5-78ab35eca015.gif":["1792161874",1200,1200,48,25.5,171,4.15],"150_585ef729-be74-4831-8edf-4ea23d115a5a.gif":["1792161844",1200,1200,48,26,170,4.15],"93_27a2e24d-dac8-463b-98a6-8c42268fecb0.gif":["1792161907",1200,1200,48,26,170,4.15],"149_1d9430b8-bac3-4fb3-a2b9-486229772397.gif":["1792161746",1200,1200,60,46.5,147,3],"9.gif":["1763144123",1080,1080,43,23,154,4.15],"63_4b449719-69bf-46d4-9a5e-4c83c3bbfec9.gif":["1767977073",864,864,34,18,124,4.15],"104.gif":["1763142492",1080,1080,43,23,154,4.15],"117_81710950-3272-4abe-9979-ea2e5abdebec.gif":["1765208366",1080,1080,43,23,154,4.15],"129.gif":["1763143297",1080,1080,42.5,23,154,4.15],"101_3c2a3406-c8a7-4bb5-bad1-d69aa3d32ea5.gif":["1767977293",864,864,34,18,124,4.15],"106.gif":["1763142620",1080,1080,43,23,154,4.15],"111.gif":["1763136246",1080,1080,43,23,154,4.15],"116.gif":["1763143542",1080,1080,43,23,154,4.15],"123.gif":["1763143400",1080,1080,43,23,154,4.15],"12_a28bd0a0-f824-4736-98f0-5757eb578cd7.gif":["1763144021",1080,1080,43,23,154,4.15],"13.gif":["1763136413",1080,1080,43,23,154,4.15],"131.gif":["1763142868",1080,1080,43,23,154,4.15],"135.gif":["1763136012",1080,1080,43,24,153,4.15],"136.gif":["1763135291",1080,1080,43,23,154,4.15],"18.gif":["1763143832",1080,1080,43,23,154,4.15],"19.gif":["1763143762",1080,1080,43,23,154,4.15],"23.gif":["1763143692",1080,1080,43,23,154,4.15],"25.gif":["1763143608",1080,1080,43,23,154,4.15],"29.gif":["1763136164",1080,1080,43,23,154,4.15],"4.gif":["1763144178",1080,1080,43,23,154,4.15],"49.gif":["1763135247",1080,1080,43,23,154,4.15],"51.gif":["1765212287",1080,1080,43,23,154,4.15],"55_ead3d19a-d0ad-4056-b0c6-dfea5b30fd88.gif":["1767979331",864,864,34,18,124,4.15],"65_19fbd268-6aa6-4663-a6b8-945785c08027.gif":["1767977136",864,864,34,18,124,4.15],"7.gif":["1763144045",1080,1080,43,23,154,4.15],"70.gif":["1765211928",1080,1080,43,23,154,4.15],"74.gif":["1763142998",1080,1080,43,23,154,4.15],"75.gif":["1763143100",1080,1080,43,23,154,4.15],"79.gif":["1763135947",1080,1080,43,23,154,4.15],"84.gif":["1763138699",1080,1080,43,23,154,4.15],"86.gif":["1763136970",1080,1080,43,23,154,4.15],"90.gif":["1763137083",1080,1080,43,23,154,4.15],"94.gif":["1763136564",1080,1080,43,23,154,4.15],"97_0c192053-eff0-449f-ac49-666b26e35a8d.gif":["1767977224",864,864,34,18,124,4.15],"Spinning_864_x_864_px_12_1.gif":["1779545601",691,691,26.5,14,100,4.15],"10.gif":["1763144123",1080,1080,43,23,154,4.15],"105.gif":["1763142492",1080,1080,43,23,154,4.15],"107.gif":["1763142621",1080,1080,43,23,154,4.15],"11.gif":["1763144123",1080,1080,43,23,154,4.15],"110.gif":["1763142692",1080,1080,43,23,154,4.15],"112.gif":["1763136246",1080,1080,43,23,154,4.15],"113.gif":["1763136246",1080,1080,43,23,154,4.15],"115.gif":["1763143542",1080,1080,43,23,154,4.15],"117.gif":["1763143542",1080,1080,43,23,154,4.15],"118.gif":["1763143542",1080,1080,43,23,154,4.15],"119.gif":["1763143400",1080,1080,43,23,154,4.15],"119_8b676754-0aab-4cf0-9a6a-2f276b72613c.gif":["1765208366",1080,1080,43,23,154,4.15],"120.gif":["1763143400",1080,1080,43,23,154,4.15],"121.gif":["1763143400",1080,1080,43,23,154,4.15],"121_e4c322b6-461e-411a-8d5e-0db468d6ae0d.gif":["1765208366",1080,1080,43,23,154,4.15],"122.gif":["1763143400",1080,1080,43,23,154,4.15],"123_587f630f-ed0c-4fe1-82c8-8650b54b4167.gif":["1765208366",1080,1080,43,23,154,4.15],"124.gif":["1763143400",1080,1080,43,23,154,4.15],"125.gif":["1763143297",1080,1080,43,23,154,4.15],"126.gif":["1763143297",1080,1080,43,23,154,4.15],"127.gif":["1763143297",1080,1080,43,23,154,4.15],"128.gif":["1763143297",1080,1080,43,23,154,4.15],"130.gif":["1763143297",1080,1080,43,23,154,4.15],"132.gif":["1763142868",1080,1080,43,23,154,4.15],"133.gif":["1763136012",1080,1080,43,23.5,154,4.15],"134.gif":["1763136012",1080,1080,43,24,153,4.15],"137.gif":["1763135291",1080,1080,43,23,154,4.15],"138.gif":["1763135291",1080,1080,43,23,154,4.15],"14.gif":["1763136413",1080,1080,43,23,154,4.15],"15.gif":["1763136413",1080,1080,43,23,154,4.15],"151_90d883f0-20ef-4782-8c33-d675f613c7b6.gif":["1792161844",1200,1200,48,26,170,4.15],"153_ed4829b8-8ab8-4464-b2e4-baefe1c03473.gif":["1792161875",1200,1200,48,26,170,4.15],"17.gif":["1763143832",1080,1080,43,23,154,4.15],"1_ed7edc3c-4c7c-4f1a-9538-8d215db5b386.gif":["1763144385",1080,1080,43,23,154,4.15],"20.gif":["1763143762",1080,1080,43,23,154,4.15],"21.gif":["1763143762",1080,1080,43,23,154,4.15],"22.gif":["1763143692",1080,1080,43,23,154,4.15],"24.gif":["1763143692",1080,1080,43,23,154,4.15],"26.gif":["1763143608",1080,1080,43,23,154,4.15],"27.gif":["1763136164",1080,1080,43,23,154,4.15],"28.gif":["1763136164",1080,1080,43,23,154,4.15],"2_0711e651-f6a3-43fa-a909-48061c738533.gif":["1763144386",1080,1080,43,23,154,4.15],"31_c4ddcfa1-c47f-4ba3-9b53-66c8432c8db5.gif":["1767977434",864,864,34,18,124,4.15],"33_f591b581-4c0b-4d86-aa3a-0a093dfe5af9.gif":["1767977434",864,864,34,18,124,4.15],"34_79028c70-2276-4865-93c3-8ada7b3fa2b8.gif":["1767977434",864,864,34,18,124,4.15],"3_6974ba07-fd67-4e9d-9126-eb07e02d319f.gif":["1777828314",864,864,34,18,124,4.15],"40_36e32457-4730-4002-ba6e-426426d7e34b.gif":["1767977501",864,864,34,18,124,4.15],"41_80d8db2f-8018-4470-81bf-f3fd73def754.gif":["1767977501",864,864,34,18,124,4.15],"44_59243c7b-6939-4492-9166-034c389d882c.gif":["1767977555",864,864,34,18,124,4.15],"5.gif":["1763144178",1080,1080,43,23,154,4.15],"50.gif":["1763135247",1080,1080,43,23,154,4.15],"52.gif":["1765212287",1080,1080,43,23,154,4.15],"53.gif":["1765212287",1080,1080,43,23,154,4.15],"56_1edd7934-92b9-4833-9ccd-bb3eea6d19aa.gif":["1767979331",864,864,34,18,124,4.15],"57_77e03f38-87ef-4612-b571-2ae3858026a1.gif":["1767979331",864,864,34,18,124,4.15],"6.gif":["1763144178",1080,1080,43,23,154,4.15],"64_b661cc72-7bef-4ccd-bbfd-8ef01129d9f6.gif":["1767977073",864,864,34,18,124,4.15],"66_0100bb8a-c586-426d-9c3a-d9d15b0975df.gif":["1767977136",864,864,34,18,124,4.15],"67_14a9a3b1-b7e2-40f7-9d4f-3d4eaa849459.gif":["1767977136",864,864,34,18,124,4.15],"69.gif":["1765211929",1080,1080,43,23,154,4.15],"71.gif":["1765211929",1080,1080,43,23,154,4.15],"73.gif":["1763142998",1080,1080,43,23,154,4.15],"78.gif":["1763135947",1080,1080,43,23,154,4.15],"8.gif":["1763144045",1080,1080,43,23,154,4.15],"83-ezgif.com-optimize.gif":["1773247436",864,864,34,18,124,4.15],"88.gif":["1763136970",1080,1080,43,23,154,4.15],"91.gif":["1763137083",1080,1080,43,23,154,4.15],"92.gif":["1763137083",1080,1080,43,23,154,4.15],"94_06bedc43-cf19-464a-8b4f-737d0a777c0a.gif":["1792161906",1200,1200,48,26,170,4.15],"95.gif":["1763136564",1080,1080,43,23,154,4.15],"95_25c9dcf3-7c3d-4a57-8fa8-1893ca62abde.gif":["1792161907",1200,1200,48,26,170,4.15],"96.gif":["1763136564",1080,1080,43,23,154,4.15],"98_00ae37a8-ca78-4645-9eec-1a5794c6ed80.gif":["1767977224",864,864,34,18,124,4.15],"99_0029669d-71bb-4761-9e53-98f5edabc471.gif":["1767977224",864,864,34,18,124,4.15],"103_1e0919ff-8f0b-4ff4-8432-9a24e43d8158.gif":["1767977293",864,864,34,18,124,4.15],"114.gif":["1763136246",1080,1080,43,23,154,4.15],"16.gif":["1763136413",1080,1080,43,23,154,4.15],"30.gif":["1763136164",1080,1080,43,23,154,4.15],"54.gif":["1765212287",1080,1080,43,23,154,4.15],"72.gif":["1765211929",1080,1080,43,23,154,4.15],"89.gif":["1763136970",1080,1080,43,23,154,4.15]};
  Object.assign(rimSources, {
    "rnf-rs7-2021-sportback-red-spinning-static-hq.png": [
      "1793720306",
      1254,
      1254,
      50,
      27,
      179,
      4.15
    ],
    "rnf-rs7-2021-sportback-green-spinning-static-hq.png": [
      "1793720323",
      1254,
      1254,
      50,
      27,
      179,
      4.15
    ]
  });
  const rimFor = source => {
    const url = new URL(source, location.href);
    const item = rimSources[url.pathname.split('/').pop()];
    return item && item[0] === url.searchParams.get('v') ? item : null;
  };
  const stillSource = source => {
    const url = new URL(source, location.href);
    if (url.pathname.toLowerCase().endsWith('.png')) url.searchParams.delete('format');
    else url.searchParams.set('format', 'jpg');
    return url.href;
  };
  const style = document.createElement('style');
  style.textContent = '.rnf-card-rim{position:absolute;overflow:hidden;pointer-events:none;background:#fff;contain:strict;z-index:1}.rnf-card-rim[hidden]{display:none!important}.rnf-card-rim>span{display:block;width:100%;height:100%;background-repeat:no-repeat;transform-origin:50% 50%;animation:rnf-card-rim-spin var(--rnf-rim-duration,4.15s) linear infinite;animation-play-state:paused}.rnf-card-rim.is-running>span{animation-play-state:running;will-change:transform;backface-visibility:hidden}@keyframes rnf-card-rim-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.rnf-card-rim>span{animation:none}}';
  document.head.append(style);
  const roots = new Map();
  const records = new Map();
  const queue = [];
  let pending = 0;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const canLoad = record => record.img.isConnected && record.visible && !document.hidden &&
    record.panel?.classList.contains('is-active') && !record.previewing &&
    (!record.animated || !reduced.matches) && (!record.secondary || record.intent);

  function showRim(record) {
    if (!record.rim || record.state !== 'loaded') return;
    let rim = record.rimElement;
    if (!rim) {
      const [, width, height, x, y, size, duration] = record.rim;
      rim = document.createElement('span');
      rim.className = 'rnf-card-rim';
      rim.setAttribute('aria-hidden', 'true');
      rim.style.cssText = `left:${x / width * 100}%;top:${y / height * 100}%;width:${size / width * 100}%;height:${size / height * 100}%;--rnf-rim-duration:${duration}s`;
      const face = document.createElement('span');
      face.style.backgroundImage = `url(${JSON.stringify(record.source)})`;
      face.style.backgroundSize = `${width / size * 100}% ${height / size * 100}%`;
      face.style.backgroundPosition = `${x / (width - size) * 100}% ${y / (height - size) * 100}%`;
      rim.append(face);
      record.media.append(rim);
      record.rimElement = rim;
    }
    rim.hidden = record.previewing || (record.secondary && !record.intent);
    rim.classList.toggle('is-running', canLoad(record) && !reduced.matches);
  }

  function suspend(record) {
    if (record.rimElement) {
      record.rimElement.classList.remove('is-running');
      record.rimElement.hidden = record.previewing || (record.secondary && !record.intent);
    }
    if (!record.animated || record.state !== 'loaded') return;
    record.img.src = record.poster;
    record.state = '';
    record.img.removeAttribute('data-rnf-load-state');
  }

  function pump() {
    while (pending < 2 && queue.length) {
      const record = queue.shift();
      if (!canLoad(record) || records.get(record.img) !== record) {
        record.state = '';
        record.img.removeAttribute('data-rnf-load-state');
        continue;
      }
      const preview = new Image();
      let settled = false;
      let timeout;
      pending++;
      record.state = 'loading';
      record.img.dataset.rnfLoadState = 'loading';
      preview.decoding = 'async';
      preview.fetchPriority = 'low';
      const finish = success => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        preview.onload = preview.onerror = null;
        record.cancelLoad = null;
        pending--;
        if (records.get(record.img) !== record) { pump(); return; }
        if (success && (!record.animated || canLoad(record))) {
          record.img.removeAttribute('srcset');
          record.img.removeAttribute('sizes');
          record.img.src = record.source;
          record.state = 'loaded';
          record.img.dataset.rnfLoadState = 'loaded';
          showRim(record);
        } else {
          record.state = success ? '' : 'failed';
          record.img.removeAttribute('data-rnf-load-state');
        }
        pump();
      };
      record.cancelLoad = () => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        preview.onload = preview.onerror = null;
        record.cancelLoad = null;
        pending--;
      };
      preview.onload = () => finish(true);
      preview.onerror = () => finish(false);
      timeout = setTimeout(() => finish(false), 12000);
      preview.src = record.source;
    }
  }

  function enqueue(record) {
    if (!canLoad(record)) return;
    if (record.state === 'loaded') { showRim(record); return; }
    if (record.state) return;
    record.state = 'queued';
    record.img.dataset.rnfLoadState = 'queued';
    queue.push(record);
  }

  function sync() {
    records.forEach(record => {
      if (canLoad(record)) enqueue(record);
      else suspend(record);
    });
    pump();
  }

  function init(root) {
    if (!root || roots.has(root)) return;
    const cards = new Map();
    const own = [];
    root.querySelectorAll('[data-rnf-quality-src]').forEach(img => {
      const card = img.closest('.grid__item');
      if (!card) return;
      const original = img.dataset.rnfQualitySrc;
      const automatic = !!img.closest('[data-rnf-automatic-media]');
      const rim = automatic ? null : rimFor(original);
      const record = {
        img, card, panel: img.closest('.rnf-tab-panel') || root, media: img.parentElement, rim,
        source: rim ? stillSource(original) : original,
        poster: img.dataset.rnfPosterSrc || img.getAttribute('src'),
        animated: !automatic && !rim && img.hasAttribute('data-rnf-animated-media'),
        secondary: img.hasAttribute('data-rnf-media-secondary'),
        state: img.dataset.rnfLoadState || '', visible: false, intent: false, previewing: false
      };
      records.set(img, record);
      own.push(record);
      if (!cards.has(card)) cards.set(card, []);
      cards.get(card).push(record);
    });
    const targets = new Map();
    cards.forEach((group, card) => targets.set(card.querySelector('.card__media, .rnf-nav-card__media') || card, group));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => targets.get(entry.target)?.forEach(record => {
        record.visible = entry.isIntersecting && entry.intersectionRatio >= .2;
        if (canLoad(record)) enqueue(record);
        else suspend(record);
      }));
      pump();
    }, { rootMargin: '0px', threshold: [0, .2] });
    targets.forEach((_, target) => observer.observe(target));
    const onPreview = event => {
      const record = records.get(event.detail?.base);
      if (!record) return;
      record.previewing = event.type === 'rnf:preview:start';
      if (record.previewing) suspend(record);
      else { enqueue(record); pump(); }
    };
    root.addEventListener('rnf:preview:start', onPreview);
    root.addEventListener('rnf:preview:end', onPreview);
    const onIntent = event => {
      if (root.hasAttribute('data-rnf-desktop-carousel-ready') && matchMedia('(min-width:990px)').matches) return;
      if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
      const card = event.target.closest('.grid__item');
      cards.get(card)?.forEach(record => { record.intent = true; enqueue(record); });
      pump();
    };
    const onOut = event => {
      const card = event.target.closest('.grid__item');
      if (!card || card.contains(event.relatedTarget)) return;
      cards.get(card)?.forEach(record => {
        record.intent = false;
        if (record.secondary) suspend(record);
      });
    };
    const tabs = new MutationObserver(sync);
    root.querySelectorAll('.rnf-tab-panel').forEach(panel => tabs.observe(panel, { attributes: true, attributeFilter: ['class'] }));
    root.addEventListener('pointerover', onIntent, { passive: true });
    root.addEventListener('focusin', onIntent);
    root.addEventListener('pointerout', onOut);
    root.addEventListener('focusout', onOut);
    const cleanup = () => {
      observer.disconnect(); tabs.disconnect();
      own.forEach(record => { suspend(record); record.cancelLoad?.(); record.rimElement?.remove(); records.delete(record.img); });
      for (let i = queue.length - 1; i >= 0; i--) if (own.includes(queue[i])) queue.splice(i, 1);
      root.removeEventListener('pointerover', onIntent);
      root.removeEventListener('focusin', onIntent);
      root.removeEventListener('pointerout', onOut);
      root.removeEventListener('focusout', onOut);
      root.removeEventListener('rnf:preview:start', onPreview);
      root.removeEventListener('rnf:preview:end', onPreview);
      roots.delete(root);
      pump();
    };
    roots.set(root, cleanup);
  }
  const surfaceWheels = new Map();
  const wheelSource = source => {
    const rim = rimFor(source);
    if (!rim) return null;
    const url = new URL(stillSource(source));
    url.searchParams.set('width', String(rim[1]));
    return url.href;
  };
  const surfaceStyle = document.createElement('style');
  surfaceStyle.textContent = '.rnf-wheel-layer{position:absolute;pointer-events:none;overflow:hidden;z-index:1;transition:transform .55s cubic-bezier(.2,.8,.2,1)}.rnf-wheel-layer[hidden]{display:none!important}.rnf-nav-card:hover .rnf-wheel-layer{transform:scale(1.035)}.rnf-nav-preview-track>.rnf-wheel-layer{transform:none!important}.rnf-maincard__media{position:relative}@media(prefers-reduced-motion:reduce){.rnf-wheel-layer{transition:none!important;transform:none!important}}';
  document.head.append(surfaceStyle);

  function syncWheel(record) {
    record.layer.hidden = record.previewing || !record.img.complete || !record.img.naturalWidth || !!record.img.closest('[hidden],dialog:not([open]),[aria-hidden="true"]:not(.rnf-cart__image-link):not(.rnf-cart__recommendation-image)');
    record.rimElement.classList.toggle('is-running', !record.layer.hidden && record.visible && !document.hidden && !reduced.matches);
  }

  function layoutWheel(record) {
    if (!record.img.isConnected) return;
    const {img, layer, rimElement, rim} = record;
    const media = img.parentElement.classList.contains('rnf-nav-preview-track')
      ? img.parentElement : img.closest('.product__media, .rnf-nav-card__media, .rnf-maincard__media, [data-rnf-wheel-media]');
    if (!media) { layer.hidden = true; return; }
    record.media = media;
    const [, width, height, x, y, size] = rim;
    const boxWidth = img.clientWidth;
    const boxHeight = img.clientHeight;
    if (!boxWidth || !boxHeight) { layer.hidden = true; return; }
    const computed = getComputedStyle(img);
    const scale = computed.objectFit === 'cover' ? Math.max(boxWidth / width, boxHeight / height) : Math.min(boxWidth / width, boxHeight / height);
    const position = computed.objectPosition.split(' ');
    const fraction = value => value?.endsWith('%') ? parseFloat(value) / 100 : value === 'top' || value === 'left' ? 0 : value === 'bottom' || value === 'right' ? 1 : .5;
    const left = (boxWidth - width * scale) * fraction(position[0]);
    const top = (boxHeight - height * scale) * fraction(position[1]);
    layer.style.cssText = `left:${img.offsetLeft}px;top:${img.offsetTop}px;width:${boxWidth}px;height:${boxHeight}px`;
    rimElement.style.cssText = `left:${left + x * scale}px;top:${top + y * scale}px;width:${size * scale}px;height:${size * scale}px;--rnf-rim-duration:${rim[6]}s`;
    if (layer.parentElement !== media) media.append(layer);
    syncWheel(record);
  }

  const wheelResize = new ResizeObserver(entries => entries.forEach(entry => {
    const record = surfaceWheels.get(entry.target);
    if (record) layoutWheel(record);
  }));
  const wheelVisibility = new IntersectionObserver(entries => entries.forEach(entry => {
    const record = surfaceWheels.get(entry.target);
    if (!record) return;
    record.visible = entry.isIntersecting && entry.intersectionRatio >= .2;
    syncWheel(record);
  }), {threshold:[0,.2]});

  function removeWheel(img) {
    const record = surfaceWheels.get(img);
    if (!record) return;
    wheelResize.unobserve(img);
    wheelVisibility.unobserve(img);
    img.removeEventListener('load', record.onLoad);
    record.layer.remove();
    surfaceWheels.delete(img);
  }

  function updateWheel(img, source) {
    const photo = wheelSource(source);
    const media = img.closest('.product__media, .rnf-nav-card__media, .rnf-maincard__media, [data-rnf-wheel-media]');
    const automatic = !!img.closest('[data-rnf-automatic-media]');
    if (!photo || !media || automatic) {
      removeWheel(img);
      img.removeAttribute('data-rnf-wheel-source');
      return false;
    }
    let record = surfaceWheels.get(img);
    if (record?.photo !== photo) {
      removeWheel(img);
      const rim = rimFor(source);
      const layer = document.createElement('span');
      layer.className = 'rnf-wheel-layer';
      layer.setAttribute('aria-hidden','true');
      layer.hidden = true;
      const rimElement = document.createElement('span');
      rimElement.className = 'rnf-card-rim';
      const face = document.createElement('span');
      face.style.backgroundImage = `url(${JSON.stringify(photo)})`;
      face.style.backgroundSize = `${rim[1] / rim[5] * 100}% ${rim[2] / rim[5] * 100}%`;
      face.style.backgroundPosition = `${rim[3] / (rim[1] - rim[5]) * 100}% ${rim[4] / (rim[2] - rim[5]) * 100}%`;
      rimElement.append(face);
      layer.append(rimElement);
      const parent = img.parentElement.classList.contains('rnf-nav-preview-track') ? img.parentElement : media;
      parent.append(layer);
      record = {img, media:parent, layer, rimElement, rim, photo, visible:false, previewing:false};
      record.onLoad = () => layoutWheel(record);
      img.addEventListener('load', record.onLoad);
      surfaceWheels.set(img,record);
      wheelResize.observe(img);
      wheelVisibility.observe(img);
    }
    img.dataset.rnfWheelSource = source;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (img.getAttribute('src') !== photo) img.src = photo;
    layoutWheel(record);
    return true;
  }

  function mountWheels(scope) {
    surfaceWheels.forEach((record,img) => { if (!img.isConnected) removeWheel(img); });
    scope.querySelectorAll('img[data-rnf-wheel-source]').forEach(img => updateWheel(img,img.dataset.rnfWheelSource));
  }
  function unmountWheels(scope, keep) {
    surfaceWheels.forEach((record,img) => { if (img !== keep && scope.contains(img)) removeWheel(img); });
  }
  for (const name of ['rnf:preview:start','rnf:preview:end']) document.addEventListener(name,event => {
    const record = surfaceWheels.get(event.detail?.base);
    if (!record) return;
    record.previewing = name === 'rnf:preview:start';
    layoutWheel(record);
  });
  const syncWheels = () => surfaceWheels.forEach(syncWheel);
  document.addEventListener('visibilitychange', syncWheels);
  reduced.addEventListener('change', syncWheels);
  document.addEventListener('shopify:section:unload', event => unmountWheels(event.target));

  function mount(scope) { scope.querySelectorAll('[data-rnf-carousel-root]').forEach(init); mountWheels(scope); }
  window.__rnfCarouselMedia = { init, mount, wheelSource, updateWheel, unmountWheels, unmount: root => roots.get(root)?.() };
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-rnf-carousel-root]').forEach(root => roots.get(root)?.());
  });
  const drawerStyle = document.createElement('style');
  drawerStyle.textContent = '.rnf-drawer-media{display:block;position:relative;width:100%;height:100%;min-width:0;min-height:0}.rnf-drawer-media>img{display:block;width:100%;height:100%;object-fit:contain!important;object-position:center}.rnf-qb__slide>.rnf-drawer-media{flex:0 1 auto;border-radius:16px;overflow:hidden}.rnf-drawer-media__spin{position:absolute;top:3%;left:3%;width:15.8%;max-width:56px;aspect-ratio:1;pointer-events:none;animation:rnf-card-rim-spin 1.1s linear infinite;animation-play-state:paused}.rnf-drawer-media__spin[hidden]{display:none!important}.rnf-drawer-media__spin img{display:block;width:100%;height:100%;object-fit:contain}.rnf-drawer-media.is-running>.rnf-drawer-media__spin{animation-play-state:running}@media(prefers-reduced-motion:reduce){.rnf-drawer-media__spin{animation:none}}';
  document.head.append(drawerStyle);
  class DrawerMedia extends HTMLElement {
    connectedCallback() {
      if (this.context) return;
      this.visible = false;
      this.context = new MutationObserver(() => this.refresh());
      this.context.observe(this, {childList:true, subtree:true, attributes:true, attributeFilter:['src']});
      this.parents = new MutationObserver(() => this.sync());
      for (let node = this; node; node = node.parentElement) {
        if (node === this || node.matches('dialog,details,[hidden],[aria-hidden],.rnf-qb__product,.rnf-qb__mount')) this.parents.observe(node,{attributes:true,attributeFilter:['open','hidden','aria-hidden']});
      }
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .2);
        this.sync();
      }, {threshold:[0,.2]});
      this.visibility.observe(this);
      this.size = new ResizeObserver(() => this.sync());
      this.size.observe(this);
      this.onVisibility = () => this.sync();
      document.addEventListener('visibilitychange', this.onVisibility);
      reduced.addEventListener('change', this.onVisibility);
      queueMicrotask(() => { if (this.isConnected) this.refresh(); });
    }
    refresh() {
      if (!this.isConnected) return;
      for (const img of this.querySelectorAll(':scope > img')) {
        const source = img.getAttribute('src');
        if (!source) continue;
        const original = img.dataset.rnfWheelSource;
        updateWheel(img, original && rimFor(source) === rimFor(original) ? original : source);
      }
      this.sync();
    }
    sync() {
      const blocked = this.closest('[hidden],dialog:not([open]),[aria-hidden="true"]:not(.rnf-cart__image-link):not(.rnf-cart__recommendation-image)');
      this.classList.toggle('is-running', this.visible && !blocked && !document.hidden && !reduced.matches);
      for (const img of this.querySelectorAll(':scope > img')) {
        if (img.hasAttribute('data-rnf-badge-mask')) {
          const width = Number(img.getAttribute('width')) || img.naturalWidth;
          const height = Number(img.getAttribute('height')) || img.naturalHeight;
          const scale = Math.min(img.clientWidth / width, img.clientHeight / height);
          const left = (img.clientWidth - width * scale) / 2;
          const top = (img.clientHeight - height * scale) / 2;
          const edgeX = left + width * scale * .21;
          const edgeY = top + height * scale * .24;
          if (Number.isFinite(edgeX) && Number.isFinite(edgeY)) img.style.clipPath = 'polygon(0 ' + edgeY + 'px,' + edgeX + 'px ' + edgeY + 'px,' + edgeX + 'px 0,100% 0,100% 100%,0 100%)';
        } else img.style.removeProperty('clip-path');
        const record = surfaceWheels.get(img);
        if (record) layoutWheel(record);
      }
    }
    disconnectedCallback() {
      this.context?.disconnect();
      this.parents?.disconnect();
      this.visibility?.disconnect();
      this.size?.disconnect();
      document.removeEventListener('visibilitychange',this.onVisibility);
      reduced.removeEventListener('change',this.onVisibility);
      unmountWheels(this);
      this.context = null;
    }
  }
  if (!customElements.get('rnf-drawer-media')) customElements.define('rnf-drawer-media', DrawerMedia);
  mount(document);
})();

